import React from "react";
import {
  fileTypeToIcon,
  formatFileSize,
} from "../../../../Utils/Email-utils/email-utils";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { Button } from "@mui/base";
import CloseIcon from "@mui/icons-material/Close";
import { connect } from "react-redux";
import { clearAttachmentItem } from "../../../../../Redux/Actions/actions";
import IconButton from '@mui/material/IconButton';

const mapStateToProps = (state) => {
  return {
    attachment: state.email.attachment,
  };
};
const EmailAttachment = (props) => {
  console.log("attachment", props.attachment);
  return (
    <Grid xs={12} item sx={{ background: "#EEF7FF", borderRadius: "7px", }} className="attachment-area p-2 ">
      <Grid container direction="row">
        <Grid md={12} sm={12} item>
          <Typography
            variant="h6"
            className="fs-13 mb-2 fw-bold"
          >
            Attachment
          </Typography>
        </Grid>

        <Grid md={12} sm={12} item>
          <Box
          className="w-100">
            <div className="attachment-container justify-content-between w-100">
              {props.attachment.length > 0
                ? props.attachment.map((data, index) => {
                  const icon = fileTypeToIcon[data.fileType];
                  return (
                    <Box
                      sx={{
                        width: "max-content",
                        border: "1px solid #cfcfcf",
                        borderRadius: "7px",
                        background: "white"
                      }}
                      key={index}
                      className="p-2 position-relative"
                    >
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        spacing={0.5}
                      >
                        <img
                          src={icon}
                          alt="File Icon"
                          width="20px"
                          height="20px"
                        />
                        <Stack spacing={0.4}>
                          <Typography
                            variant="caption"
                            noWrap
                            sx={{ width: "100px" }}
                          >
                            {data.filename}
                          </Typography>
                          <div className="file-size">
                            {formatFileSize(data.filesize)}
                          </div>
                        </Stack>
                        <div className="close-attach">

                          <button type="button" className="close-btn-attach" onClick={() => {
                            props.clearAttachmentItem(
                              props.attachment,
                              index
                            );
                          }}
                           >
                            <CloseIcon className="fs-13" />
                          </button>
                        </div>
                      </Stack>
                    </Box>
                  );
                })
                : null}
            </div>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default connect(mapStateToProps, {
  clearAttachmentItem,
})(EmailAttachment);
